// extracted by mini-css-extract-plugin
export default {"stat-control":"stat-control_stat-control__yQ39F","icon-root":"stat-control_icon-root__rdE1x","active":"stat-control_active__ykHq+"};